import { Link } from 'react-router-dom';
import { CALCULATORS } from '../../config/calculators';

export default function Footer() {
  return (
    <footer className="w-full px-8 py-10" style={{ backgroundColor: 'var(--surface-container-low)', borderTop: '1px solid var(--outline-variant)' }}>
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h2 className="font-mono text-[10px] font-bold tracking-widest text-[#0078d4] uppercase mb-3">Calculators</h2>
            <ul className="flex flex-col gap-2">
              {CALCULATORS.map(({ path, name }) => (
                <li key={path}>
                  <Link className="font-mono text-xs transition-colors" style={{ color: 'var(--text-tertiary)' }} to={path} discover="none">{name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-mono text-[10px] font-bold tracking-widest text-[#0078d4] uppercase mb-3">Pricing Guides</h2>
            <ul className="flex flex-col gap-2">
              {[
                { to: '/guides/azure-billing-traps-uk',                 label: 'Azure Billing Traps' },
                { to: '/guides/invoice-reconciliation',                label: 'Invoice Reconciliation' },
                { to: '/prompt-answers',                               label: 'Prompt Answers (AI)' },
                { to: '/guides/azure-networking-costs-uk',              label: 'Networking Hidden Costs' },
                { to: '/guides/azure-data-factory-pricing-uk',           label: 'Data Factory Pricing' },
                { to: '/guides/azure-virtual-desktop-pricing-uk',        label: 'Virtual Desktop Pricing' },
                { to: '/guides/azure-front-door-pricing-uk',             label: 'Front Door Pricing' },
                { to: '/guides/azure-sql-pricing-uk',                    label: 'SQL Database Pricing' },
                { to: '/guides/azure-openai-pricing-uk',                 label: 'Azure OpenAI Pricing' },
                { to: '/guides/azure-blob-storage-pricing-uk',          label: 'Blob Storage Pricing' },
                { to: '/guides/azure-log-analytics-pricing-uk',         label: 'Log Analytics Pricing' },
                { to: '/guides/azure-egress-bandwidth-costs-explained', label: 'Egress Costs Explained' },
                { to: '/guides/log-analytics-search-job-vs-restore',    label: 'Search Job vs Restore' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link className="font-mono text-xs transition-colors" style={{ color: 'var(--text-tertiary)' }} to={to} discover="none">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-mono text-[10px] font-bold tracking-widest text-[#0078d4] uppercase mb-3">Certifications</h2>
            <ul className="flex flex-col gap-2">
              {[
                { to: '/certifications/az-900-study-guide-uk', label: 'AZ-900 Study Guide' },
                { to: '/certifications/az-104-study-guide-uk', label: 'AZ-104 Study Guide' },
                { to: '/certifications/az-500-study-guide-uk', label: 'AZ-500 Study Guide' },
                { to: '/certifications/sc-200-study-guide-uk', label: 'SC-200 Study Guide' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link className="font-mono text-xs transition-colors" style={{ color: 'var(--text-tertiary)' }} to={to} discover="none">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-mono text-[10px] font-bold tracking-widest text-[#0078d4] uppercase mb-3">Legal</h2>
            <ul className="flex flex-col gap-2">
              {[
                { to: '/changelog',    label: 'Changelog' },
                { to: '/about',        label: 'About' },
                { to: '/methodology',  label: 'How prices are calculated →' },
                { to: '/privacy',      label: 'Privacy Policy' },
                { to: '/disclaimer',   label: 'Disclaimer' },
                { to: '/faq',          label: 'FAQ' },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link className="font-mono text-xs transition-colors" style={{ color: 'var(--text-tertiary)' }} to={to} discover="none">{label}</Link>
                </li>
              ))}
              <li>
                <a
                  className="font-mono text-xs transition-colors"
                  style={{ color: 'var(--text-tertiary)' }}
                  href="https://azure.status.microsoft/en-gb/status"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Azure Status ↗
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 text-center" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <p className="font-mono text-xs" style={{ color: 'var(--text-tertiary)' }}>
            © {new Date().getFullYear()} AzureCalc.uk · Prices updated daily · Estimates are indicative only · Not affiliated with Microsoft Corporation
          </p>
        </div>
      </div>
    </footer>
  );
}
